export const NAME = 'eventsHome';
export const ID = 'events-home';
